// extracted by mini-css-extract-plugin
export default {"container":"CurrentJobsScreen_container__jWMwI"};